import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import { Button } from "signoxe/components/widgets";
import Box from "signoxe/components/layout/Box";

import "./styles.scss";

/*
-------------x(w)COLS-------------->
|
|
|
y(h)ROWS
|
|
|
|
˅
*/

export default class SelectChannelLayoutPreset extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    profile: PropTypes.object,
  };
  // static defaultProps = {
  //   rows: 12,
  //   cols: 12,
  // };

  constructor(props) {
    super(props);
    this.state = {
      selectedPreset: 1,
      rows: 12,
      cols: 12,
    };
  }

  handleRowChange = (e) => {
    const value = Math.max(1, parseInt(e.target.value, 10));
    this.setState({ rows: value });
  };

  handleColumnChange = (e) => {
    const value = Math.max(1, parseInt(e.target.value, 10));
    this.setState({ cols: value });
  };
  singleRegionsPreset = [
    {
      thumbnail: "/images/default.png",
      regions: function (rows, cols) {
        return [{ x: 0, y: 0, w: cols, h: rows }];
      },
    },
  ];

  getTwoPresets = () => {
    const { rows, cols } = this.state;
    const notEven = rows % 2 !== 0 || cols % 2 !== 0

    const twoPresets = [
      {
        thumbnail: "/images/default.png",
        regions: function (rows, cols) {
          return [{ x: 0, y: 0, w: cols, h: rows }];
        },
      },
      {
        thumbnail: "/images/1.png",
        regions: function (rows, cols) {
          return [
            { x: 0, y: 0, w: cols, h: rows / 2 },
            { x: 0, y: cols / 2, w: cols, h: rows / 2 },
          ];
        },
      },
    ];
    if (rows > 12 || cols > 12 || notEven) {
      return this.singleRegionsPreset;
    } else {
      return twoPresets;
    }
  };

  getregionsPresets = () => {
    const { rows, cols } = this.state;
    const notEven = rows % 2 !== 0 || cols % 2 !== 0

    const regionsPresets = [
      {
        thumbnail: "/images/default.png",
        regions: function (rows, cols) {
          return [{ x: 0, y: 0, w: cols, h: rows }];
        },
      },
      {
        thumbnail: rows <= 12 || cols <= 12 ? "/images/1.png" : "",
        regions: function (rows, cols) {
          return [
            { x: 0, y: 0, w: cols, h: rows / 2 },
            { x: 0, y: cols / 2, w: cols, h: rows / 2 },
          ];
        },
      },
      {
        thumbnail: rows <= 12 || cols <= 12 ? "/images/2.png" : "",
        regions: function (rows, cols) {
          return [
            { x: 0, y: 0, w: cols / 2, h: rows / 2 },
            { x: 0, y: rows / 2, w: cols / 2, h: rows / 2 },
            { x: cols / 2, y: 0, w: cols / 2, h: rows / 2 },
            { x: cols / 2, y: rows / 2, w: cols / 2, h: rows / 2 },
          ];
        },
      },
    ];

    if (rows > 12 || cols > 12 || notEven) {
      return this.singleRegionsPreset;
    } else {
      return regionsPresets;
    }
  };

  renderConditionPresets = (rows, cols, index) => {
    if (this.props.profile.max_region_no <= 1) {
      this.props.onSelect(this.singleRegionsPreset[index].regions(rows, cols));
    } else if (this.props.profile.max_region_no == 2) {
      this.props.onSelect(this.getTwoPresets()[index].regions(rows, cols));
      return twoPresets;
    } else {
      this.props.onSelect(this.getregionsPresets()[index].regions(rows, cols) , rows, cols);
    }
  };
  onSelect(index) {
    const { rows, cols } = this.state;
    this.setState({ selectedPreset: index }, () => {
      this.renderConditionPresets(rows, cols, index);
      // this.props.onSelect(regionsPresets[index].regions(rows, cols));
    });
  }

  render() {
    const profile = this.props.profile
    const features = profile && this.props.profile.features
    const isDynamicGrid = profile && features && this.props.profile.features.dynamic_grid_layouting

    const { rows, cols } = this.state;
    console.log("rows", rows);
    console.log("cols", cols);
    const disabled =((rows + cols) % 2 !== 0) || rows > 36 || rows < 4 || cols > 36 || cols < 4;
    const errorMessage  =(rows > 36 || rows < 4 || cols > 36 || cols < 4)
        ? "Layout presets disabled for rows/columns outside 4-36."
        : "Layout presets disabled due to an odd sum of rows and columns."
    
    return (
      <>
        {isDynamicGrid &&
        <Box direction="row" alignItems="center" className="grid-size-inputs">
          <span className="label secondary">Grid Sizes:</span>
          <div
            style={{
              display: "flex",
              margin: "1rem",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            <label htmlFor="row_grid">Row:</label>
            <input
              type="number"
              id="row_grid"
              name="row_grid"
              value={rows}
              min="1"
              onChange={this.handleRowChange}
            />
            <label htmlFor="column_grid">Column:</label>
            <input
              type="number"
              id="column_grid"
              name="column_grid"
              value={cols}
              min="1"
              onChange={this.handleColumnChange}
            />
          </div>
        </Box>}
        <Box
          direction="row"
          alignItems="center"
          className="layout-preset-selector filter-control"
        >
          <span className="label secondary">
            Layout Preset:{" "}
            {this.props.profile && this.props.profile.max_region_no} ----
          </span>
          {this.props.profile &&
            this.props.profile.max_region_no >= 4 &&
            this.getregionsPresets().map((regionPreset, i) => {
              return (
                <>
                  <Button
                    key={i}
                    className={classNames("small", "hollow")}
                    onClick={this.onSelect.bind(this, i)}
                    hide={regionPreset.thumbnail === "" ? true : false}
                    isDisabled={disabled}
                  >
                    <img src={regionPreset.thumbnail} />
                  </Button>
                </>
              );
            })}
          <small></small>
          {this.props.profile &&
            this.props.profile.max_region_no == 1 &&
            this.singleRegionsPreset.map((regionPreset, i) => {
              return (
                <Button
                  key={i}
                  className={classNames("small", "hollow")}
                  onClick={this.onSelect.bind(this, i)}
                >
                  <img src={regionPreset.thumbnail} />
                </Button>
              );
            })}
          {this.props.profile &&
            this.props.profile.max_region_no == 2 &&
            this.props.profile.max_region_no &&
            this.getTwoPresets().map((regionPreset, i) => {
              return (
                <Button
                  key={i}
                  className={classNames("small", "hollow")}
                  onClick={this.onSelect.bind(this, i)}
                >
                  <img src={regionPreset.thumbnail} />
                </Button>
              );
            })}

          {this.props.profile &&
            this.props.profile.max_region_no == 3 &&
            this.props.profile.max_region_no &&
            this.getTwoPresets().map((regionPreset, i) => {
              return (
                <Button
                  key={i}
                  className={classNames("small", "hollow")}
                  onClick={this.onSelect.bind(this, i)}
                >
                  <img src={regionPreset.thumbnail} />
                </Button>
              );
            })}
        </Box>
       {disabled ? <small className="hide-for-mobile" style={{color:"red", marginLeft:"9rem"}}>{errorMessage}</small> : null}
       {disabled ? <small className="hide-for-desktop" style={{color:"red"}}>{errorMessage}</small> : null}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/SelectChannelLayoutPreset/index.js